import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import { HiOutlineXMark } from "react-icons/hi2";
import "./SharedModal.css"; // Kept for safety if it contains specific legacy overrides

const SharedModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  customWidth = "600px",
  customClass = "",
}) => {
  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose} 
      fullWidth 
      disableEnforceFocus
      PaperProps={{
        className: `shared-modal-paper ${customClass}`,
        style: { maxWidth: customWidth, width: '100%', margin: '16px' }
      }}
    >
      <DialogTitle sx={{ m: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        {onClose && (
          <IconButton 
            onClick={onClose} 
            sx={{ color: (theme) => theme.palette.grey[500], p: 0.5 }}
          >
            <HiOutlineXMark size={22} />
          </IconButton>
        )}
      </DialogTitle>
      
      <DialogContent dividers>
        {children}
      </DialogContent>
      
      {footer && (
        <DialogActions>
          {footer}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default SharedModal;
